module.exports = __webpack_public_path__ + "static/media/folder.da5f1b00.svg";